import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideRouter, withPreloading } from '@angular/router';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

import { routes } from './router/app.routes';
import { RetryInterceptor } from './core/interceptors/retry.interceptor';
import { TimeoutInterceptor } from './core/interceptors/timeout.interceptor';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { CsrfInterceptor } from './core/interceptors/csrf.interceptor';
import { AuthDebugInterceptor } from './core/interceptors/auth-debug.interceptor';
import { CustomPreloadStrategy } from './core/strategies/preload.strategy';
import {
  LucideAngularModule,
  AppWindow,
  BookText,
  Building,
  RefreshCw,
  Bell,
  Shield,
  User,
  Wrench,
} from 'lucide-angular';

ModuleRegistry.registerModules([AllCommunityModule]);

export const appConfig: ApplicationConfig = {
  providers: [
    // Zone.js configuration
    provideZoneChangeDetection({ eventCoalescing: true }),

    // Router with custom preload strategy
    provideRouter(routes, withPreloading(CustomPreloadStrategy)),

    // Lucide icon set for standalone components
    importProvidersFrom(
      LucideAngularModule.pick({
        AppWindow,
        BookText,
        Building,
        RefreshCw,
        Bell,
        Shield,
        User,
        Wrench,
      }),
      FormsModule,
    ),

    // HttpClient with interceptors
    provideHttpClient(withInterceptorsFromDi()),

    // HTTP Interceptors (applied in reverse order)
    { provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RetryInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CsrfInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthDebugInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
};
